import { Typography } from '@material-ui/core'

import LimitationImage from 'assets/images/pro-limitation.png'

import { DialogBody } from './DialogBody'

import { useRoles, useServiceUsage } from 'hooks'

const rose = 'rgba(246, 165, 193, 0.9)'
const roseLight = 'rgba(215, 169, 223, 0.9)'

type Props = {
    onClose: () => void
    onPrimaryClick: () => void
}

export const ProLimitationDialog = ({ onClose, onPrimaryClick }: Props) => {
    const { isAdmin } = useRoles()

    const { usedPercent, isLoading, planName } = useServiceUsage()

    if (isLoading) return null

    return (
        <DialogBody
            isOpen
            onClose={onClose}
            image={LimitationImage}
            bubblesBackground={[rose, roseLight]}
            onPrimaryClick={onPrimaryClick}
            skipAdmin
            primaryText={isAdmin ? 'Upgrade plan' : 'Contact your admin'}
            title="Keep on going!"
            text={
                <Typography>
                    Your team reached{' '}
                    <Typography component="span" style={{ color: '#cb0000' }}>
                        {usedPercent}% of your {planName}
                    </Typography>{' '}
                    plan. Upgrade to get the best plan for your team's needs
                </Typography>
            }
        />
    )
}
